import { useEffect } from "react";
import { getComplaintsCount } from "../Redux/complaints/action";
import { getWorkforceCount } from "../Redux/locations/action";
import { toTimestamps, DEFAULT_RANGE_TYPE } from "../Utils/dateRange";

export default function useComplaints({ isAuth, allowedZones }) {
  useEffect(() => {
    if (isAuth) {
      const { from, to } = toTimestamps(DEFAULT_RANGE_TYPE);
      getComplaintsCount(from, to, allowedZones);
      getWorkforceCount(from, to, allowedZones);
    }
  }, [isAuth, allowedZones]);
}
